import { useMutation } from '@tanstack/react-query';
import { contentReportParams, reportContent } from '../queries/reports';

export function useReportContent() {
  const { data, isError, error, isSuccess, isPending, mutateAsync } =
    useMutation({
      mutationKey: ['report-content'],
      mutationFn: (params: contentReportParams) => reportContent(params),
      retry: false,
    });

  return {
    isSuccess,
    data,
    isError,
    error,
    isLoading: isPending,
    mutateAsync,
  };
}
